<template>
  <svg
    id="Meus"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 235.89 205.64"
  >
    <g
      id="Retângulo_17"
      data-name="Retângulo 17"
      transform="translate(0 29.64)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <rect
      id="Retângulo_18"
      data-name="Retângulo 18"
      width="98"
      height="158"
      transform="translate(91 23.64)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-user-alt"
      data-name="Icon awesome-user-alt"
      d="M85.362,96.032A48.016,48.016,0,1,0,37.346,48.016,48.028,48.028,0,0,0,85.362,96.032Zm42.681,10.67H109.67a58.044,58.044,0,0,1-48.616,0H42.681A42.678,42.678,0,0,0,0,149.383v5.335a16.01,16.01,0,0,0,16.005,16.005H154.718a16.01,16.01,0,0,0,16.005-16.005v-5.335A42.678,42.678,0,0,0,128.043,106.7Z"
      transform="translate(65.166)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
